// extracted by mini-css-extract-plugin
export default {"navigation":"Navigation_navigation__6uHR4","is-active":"Navigation_is-active__hHRS1","is-disabled":"Navigation_is-disabled__EuzdI"};